import { Component, Inject, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { SignupComponent } from '../signup/signup.component';
import { CreateAccountDialogConfigOptions } from './createAccountDialogConfigOptions';

@Component({
    imports: [
        MatDialogModule,
        AngularSvgIconModule,
        SignupComponent,
        AnalyticsDirective,
    ],
    selector: 'rdx-login-create-account',
    styleUrls: ['./login-create-account.component.scss'],
    templateUrl: './login-create-account.component.html',
})
export class LoginCreateAccountComponent implements OnInit {
    options: CreateAccountDialogConfigOptions =
        {} as CreateAccountDialogConfigOptions;
    title = '';
    navigateTo = '';

    constructor(
        private dialogRef: MatDialogRef<LoginCreateAccountComponent>,
        @Inject(MAT_DIALOG_DATA) private data: CreateAccountDialogConfigOptions
    ) {}

    ngOnInit() {
        this.options = new CreateAccountDialogConfigOptions(this.data);
        this.navigateTo = this.options.navigateTo;
    }

    signIn() {
        this.dialogRef.close('login');
    }

    signUp() {
        this.dialogRef.close('signUp');
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
